function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useContext, useEffect } from 'react';
import { usePrefixCls } from '@byte-design/config';
import { useChildrenEnterLeave } from '../../hooks/animation';
import { Check } from '../../common/icons';
import { StepsContext } from './context/steps';
import { Step } from './Step';
export function StepNumber(props) {
  var _props$index = props.index,
      index = _props$index === void 0 ? 0 : _props$index,
      extra = _objectWithoutProperties(props, ["index"]);

  var _useContext = useContext(StepsContext),
      current = _useContext.current,
      fill = _useContext.fill,
      size = _useContext.size;

  var finish = current > index;
  var cls = usePrefixCls('step-number', {
    fill: fill,
    finish: finish,
    size: size
  });
  var stepContent = finish ? React.createElement(Check, {
    key: "icon",
    strokeWidth: 6
  }) : React.createElement("span", {
    key: "number"
  }, index + 1);

  var _useChildrenEnterLeav = useChildrenEnterLeave(stepContent, {
    duration: 400,
    childRefKey: null,
    enterTick: function enterTick() {
      return void 0;
    },
    ignoreInitialRender: true,
    skipChildWithoutRef: false,
    enterChildProps: {
      'data-motion-fade': 'in'
    },
    leaveChildProps: {
      'data-motion-fade': 'out'
    }
  }),
      _useChildrenEnterLeav2 = _slicedToArray(_useChildrenEnterLeav, 2),
      animatedStepContent = _useChildrenEnterLeav2[0],
      startAnimation = _useChildrenEnterLeav2[1];

  useEffect(startAnimation);
  return React.createElement(Step, Object.assign({
    index: index,
    content: React.createElement("div", {
      className: cls
    }, animatedStepContent)
  }, extra));
}